import React from 'react';
import { Separator } from "./separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./breadcrumb";
import { SidebarTrigger } from "./sidebar";
import { NavigationProps, AppPage } from "@/types/navigation";
import { ROUTES } from "@/routes/routes";

interface PageHeaderProps extends NavigationProps {
  currentPage: string;
  showDashboardLink?: boolean;
}

export function PageHeader({ onNavigate, currentPage, showDashboardLink = false }: PageHeaderProps) {
  return (
    <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            {showDashboardLink && (
              <>
                <BreadcrumbItem className="hidden md:block">
                  <BreadcrumbLink 
                    href={ROUTES.DASHBOARD}
                    onClick={(e) => {
                      e.preventDefault();
                      onNavigate('dashboard');
                    }}
                  >
                    Dashboard
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="hidden md:block" />
              </>
            )}
            <BreadcrumbItem>
              <BreadcrumbPage>{currentPage}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>   
        </Breadcrumb>
      </div>
    </header>
  );
} 